import { Component ,Inject, ChangeDetectorRef, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from './_services';
import { Account, Role } from './_models';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { FadvApplicationComponent, FadvIconLibraryService, breakpointPixels } from '@fa-switch-sharedservices/ng-elements';
import Hotjar from '@hotjar/browser';

import { environment } from '../environments/environment';

@Component({ selector: 'app', templateUrl: 'app.component.html' , styleUrls: ['./app.component.scss']})
export class AppComponent {
    Role = Role;
    account: Account;
    hideHeader: boolean;
    showHelpCenter: boolean = true;
    innerWidth: number;
    showHelpCenterText: boolean = true;
    partner: boolean = false;
    imageStyle: string = "width: 200px; height: 75px;"
    partnerLogo: string;
    showLogo: boolean;
    backgroundStyle: string;
    lostSession: boolean = false;
    @ViewChild('application') application!: FadvApplicationComponent;

    constructor(
      private accountService: AccountService,
      @Inject(Router) private router: Router, 
      @Inject(FadvIconLibraryService) iconLibraryService: FadvIconLibraryService,
      private tooltipMessenger: TooltipMessageService,
      private cdref: ChangeDetectorRef

      ) {
        this.accountService.account.subscribe(x => {
          if (x != null){
            this.account = x;
          }
          else{
            this.account = this.accountService.getAccount();
          }
          var hello = "dogtown";
        });
        
        iconLibraryService.useFontAwesome();
        iconLibraryService.setBasePath('/assets');
        this.handleViewChange();
        this.tooltipMessenger.currentDisableHeader.subscribe(hideHeader => this.hideHeader = hideHeader);
        Hotjar.init(
          environment.hotjarConfig.id,
          environment.hotjarConfig.version
        );
    }

    @HostListener('window:resize', ['$event'])

    onResize(event){
        this.innerWidth = window.innerWidth;
        this.handleViewChange();
    }

    handleViewChange() : void {
      if (this.innerWidth <= breakpointPixels.sm) {
        this.showHelpCenterText = false;
      } else {
        this.showHelpCenterText = true;
      }
    }
  
  ngOnInit(){
    this.showLogo = true;
    this.backgroundStyle = "glass-vertical";
    if (window.location.href.indexOf('/pdf/') < 0) {
      this.showLogo = true;
      this.backgroundStyle = "glass-vertical";
    }
    else{
      this.showLogo = false;
      this.backgroundStyle = "";
    }
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

}
